export const VerifyPasswordIcon = () => {
  return (
    <svg
      style={{ width: "auto" }}
      height="550"
      viewBox="0 0 836 642"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_271_97)">
        <path
          d="M418 641.833C597.051 641.833 742.2 633.372 742.2 622.936C742.2 612.499 597.051 604.039 418 604.039C238.948 604.039 93.7988 612.499 93.7988 622.936C93.7988 633.372 238.948 641.833 418 641.833Z"
          fill="#F5F5F5"
        />
        <mask id="path-2-inside-1_271_97" fill="white">
          <path d="M398.605 472.929H75.7413C70.5581 472.929 66.2109 468.581 66.2109 463.397V9.53217C66.2109 4.34801 70.5581 0 75.7413 0H398.605C403.955 0 408.135 4.34801 408.135 9.53217V463.397C408.135 468.581 403.788 472.929 398.605 472.929ZM75.7413 0.334462C70.7253 0.334462 66.5453 4.34801 66.5453 9.53217V463.397C66.5453 468.414 70.5581 472.595 75.7413 472.595H398.605C403.621 472.595 407.801 468.581 407.801 463.397V9.53217C407.801 4.51524 403.788 0.334462 398.605 0.334462H75.7413Z" />
        </mask>
        <path
          d="M398.605 472.929H75.7413C70.5581 472.929 66.2109 468.581 66.2109 463.397V9.53217C66.2109 4.34801 70.5581 0 75.7413 0H398.605C403.955 0 408.135 4.34801 408.135 9.53217V463.397C408.135 468.581 403.788 472.929 398.605 472.929ZM75.7413 0.334462C70.7253 0.334462 66.5453 4.34801 66.5453 9.53217V463.397C66.5453 468.414 70.5581 472.595 75.7413 472.595H398.605C403.621 472.595 407.801 468.581 407.801 463.397V9.53217C407.801 4.51524 403.788 0.334462 398.605 0.334462H75.7413Z"
          fill="white"
        />
        <path
          d="M408.135 463.397H406.135H408.135ZM398.605 470.929H75.7413V474.929H398.605V470.929ZM75.7413 470.929C71.663 470.929 68.2109 467.477 68.2109 463.397H64.2109C64.2109 469.686 69.4532 474.929 75.7413 474.929V470.929ZM68.2109 463.397V9.53217H64.2109V463.397H68.2109ZM68.2109 9.53217C68.2109 5.45223 71.6631 2 75.7413 2V-2C69.4532 -2 64.2109 3.24379 64.2109 9.53217H68.2109ZM75.7413 2H398.605V-2H75.7413V2ZM398.605 2C402.827 2 406.135 5.42931 406.135 9.53217H410.135C410.135 3.26671 405.083 -2 398.605 -2V2ZM406.135 9.53217V463.397H410.135V9.53217H406.135ZM406.135 463.397C406.135 467.477 402.683 470.929 398.605 470.929V474.929C404.893 474.929 410.135 469.686 410.135 463.397H406.135ZM75.7413 -1.66554C69.6442 -1.66554 64.5453 3.22014 64.5453 9.53217H68.5453C68.5453 5.47587 71.8065 2.33446 75.7413 2.33446V-1.66554ZM64.5453 9.53217V463.397H68.5453V9.53217H64.5453ZM64.5453 463.397C64.5453 469.495 69.4296 474.595 75.7413 474.595V470.595C71.6867 470.595 68.5453 467.334 68.5453 463.397H64.5453ZM75.7413 474.595H398.605V470.595H75.7413V474.595ZM398.605 474.595C404.702 474.595 409.801 469.709 409.801 463.397H405.801C405.801 467.454 402.539 470.595 398.605 470.595V474.595ZM409.801 463.397V9.53217H405.801V463.397H409.801ZM409.801 9.53217C409.801 3.43481 404.916 -1.66554 398.605 -1.66554V2.33446C402.659 2.33446 405.801 5.59566 405.801 9.53217H409.801ZM398.605 -1.66554H75.7413V2.33446H398.605V-1.66554Z"
          fill="#25ABE1"
          mask="url(#path-2-inside-1_271_97)"
        />
        <mask id="path-4-inside-2_271_97" fill="white">
          <path d="M760.258 472.929H437.395C432.044 472.929 427.864 468.581 427.864 463.397V9.53217C427.864 4.34801 432.211 0 437.395 0H760.258C765.441 0 769.788 4.18078 769.788 9.53217V463.397C769.788 468.581 765.608 472.929 760.258 472.929ZM437.395 0.334462C432.379 0.334462 428.199 4.34801 428.199 9.53217V463.397C428.199 468.414 432.211 472.595 437.395 472.595H760.258C765.274 472.595 769.454 468.581 769.454 463.397V9.53217C769.454 4.51524 765.441 0.334462 760.258 0.334462H437.395Z" />
        </mask>
        <path
          d="M760.258 472.929H437.395C432.044 472.929 427.864 468.581 427.864 463.397V9.53217C427.864 4.34801 432.211 0 437.395 0H760.258C765.441 0 769.788 4.18078 769.788 9.53217V463.397C769.788 468.581 765.608 472.929 760.258 472.929ZM437.395 0.334462C432.379 0.334462 428.199 4.34801 428.199 9.53217V463.397C428.199 468.414 432.211 472.595 437.395 472.595H760.258C765.274 472.595 769.454 468.581 769.454 463.397V9.53217C769.454 4.51524 765.441 0.334462 760.258 0.334462H437.395Z"
          fill="white"
        />
        <path
          d="M769.788 463.397H771.788H769.788ZM760.258 470.929H437.395V474.929H760.258V470.929ZM437.395 470.929C433.172 470.929 429.864 467.5 429.864 463.397H425.864C425.864 469.663 430.917 474.929 437.395 474.929V470.929ZM429.864 463.397V9.53217H425.864V463.397H429.864ZM429.864 9.53217C429.864 5.45223 433.316 2 437.395 2V-2C431.107 -2 425.864 3.24378 425.864 9.53217H429.864ZM437.395 2H760.258V-2H437.395V2ZM760.258 2C764.359 2 767.788 5.30778 767.788 9.53217H771.788C771.788 3.05378 766.523 -2 760.258 -2V2ZM767.788 9.53217V463.397H771.788V9.53217H767.788ZM767.788 463.397C767.788 467.5 764.481 470.929 760.258 470.929V474.929C766.736 474.929 771.788 469.663 771.788 463.397H767.788ZM437.395 -1.66554C431.298 -1.66554 426.199 3.22014 426.199 9.53217H430.199C430.199 5.47587 433.46 2.33446 437.395 2.33446V-1.66554ZM426.199 9.53217V463.397H430.199V9.53217H426.199ZM426.199 463.397C426.199 469.495 431.083 474.595 437.395 474.595V470.595C433.34 470.595 430.199 467.334 430.199 463.397H426.199ZM437.395 474.595H760.258V470.595H437.395V474.595ZM760.258 474.595C766.355 474.595 771.454 469.709 771.454 463.397H767.454C767.454 467.454 764.193 470.595 760.258 470.595V474.595ZM771.454 463.397V9.53217H767.454V463.397H771.454ZM771.454 9.53217C771.454 3.43481 766.57 -1.66554 760.258 -1.66554V2.33446C764.313 2.33446 767.454 5.59566 767.454 9.53217H771.454ZM760.258 -1.66554H437.395V2.33446H760.258V-1.66554Z"
          fill="#25ABE1"
          mask="url(#path-4-inside-2_271_97)"
        />
        <path
          d="M143.625 557.716H74.7383V558.217H143.625V557.716Z"
          fill="#E0E0E0"
        />
        <path
          d="M284.073 554.371H215.02V554.873H284.073V554.371Z"
          fill="#E0E0E0"
        />
        <path
          d="M374.027 554.371H357.307V554.873H374.027V554.371Z"
          fill="#E0E0E0"
        />
        <path
          d="M206.994 568.586H129.58V569.087H206.994V568.586Z"
          fill="#E0E0E0"
        />
        <path
          d="M474.347 557.381H438.231V557.883H474.347V557.381Z"
          fill="#E0E0E0"
        />
        <path
          d="M535.876 557.381H489.228V557.883H535.876V557.381Z"
          fill="#E0E0E0"
        />
        <path
          d="M761.095 564.572H656.762V565.074H761.095V564.572Z"
          fill="#E0E0E0"
        />
        <path d="M836 541.327H0V541.829H836V541.327Z" fill="#EBEBEB" />
        <path
          opacity="0.8"
          d="M559.785 34.784L555.605 91.9771C555.438 93.9838 554.602 95.8234 553.264 97.1612C551.76 98.8335 549.586 99.8369 547.245 99.8369H501.265C499.593 99.8369 498.088 99.3352 496.751 98.3318C494.912 96.994 493.741 94.6528 493.908 91.9771L498.088 34.6168C498.423 30.2688 502.101 26.757 506.448 26.757H552.428C556.943 26.9242 560.12 30.436 559.785 34.784Z"
          fill="#E0E0E0"
        />
        <path
          d="M539.888 60.7049C539.219 69.2337 533.2 76.0901 526.178 76.0901C519.155 76.0901 514.139 69.2337 514.641 60.7049C515.31 52.1761 521.329 45.3196 528.351 45.3196C535.374 45.3196 540.557 52.1761 539.888 60.7049Z"
          fill="white"
        />
        <path
          d="M545.74 95.8234H503.606C500.931 95.8234 499.091 94.4855 499.091 92.8132C498.924 90.1375 512.635 78.933 525.509 79.9364H525.676H525.843C533.702 79.9364 541.226 83.2811 547.579 88.298C553.766 93.1477 547.914 95.8234 545.74 95.8234Z"
          fill="white"
        />
        <path
          d="M322.696 97.6629C313.667 97.8301 305.809 90.6392 305.14 81.6087C304.471 72.5782 311.159 65.2201 320.021 65.2201C329.049 65.0529 336.908 72.2438 337.577 81.2743C338.413 90.3047 331.725 97.6629 322.696 97.6629ZM320.689 73.9161C316.509 73.9161 313.333 77.4279 313.667 81.6087C314.001 85.7895 317.68 89.1341 321.86 89.1341C326.04 89.1341 329.217 85.6223 328.882 81.4415C328.715 77.2607 325.037 73.9161 320.689 73.9161Z"
          fill="#E0E0E0"
        />
        <path
          d="M323.531 72.5783L317.345 72.7455L314.168 33.1117L320.187 32.9445L323.531 72.5783Z"
          fill="#E0E0E0"
        />
        <path
          d="M326.039 34.784L314.503 34.9513L314.001 28.7637L325.538 28.5965L326.039 34.784Z"
          fill="#E0E0E0"
        />
        <path
          d="M326.708 42.6439L315.84 42.8111L315.339 36.6236L326.207 36.4564L326.708 42.6439Z"
          fill="#E0E0E0"
        />
        <path
          d="M327.712 53.8484L318.181 54.0156L317.68 47.8281L327.21 47.6608L327.712 53.8484Z"
          fill="#E0E0E0"
        />
        <path
          d="M132.589 434.801C132.589 435.302 132.757 435.804 132.757 436.306C133.258 439.483 134.93 442.493 137.271 444.667C139.946 447.176 143.457 448.681 147.303 448.681H288.587C295.777 448.681 301.294 443.329 301.461 436.306C301.461 435.804 301.461 435.302 301.461 434.801C301.127 430.954 299.455 427.443 296.78 425.101C294.105 422.593 290.593 421.088 286.748 421.088H145.464C137.773 421.088 132.088 427.275 132.589 434.801Z"
          fill="#F0F0F0"
        />
        <path
          d="M301.628 436.306C301.628 436.807 301.628 437.142 301.461 437.644C301.127 433.965 299.287 430.787 296.779 428.446C294.104 425.937 290.593 424.432 286.747 424.432L136.435 424.6C138.775 422.426 141.952 421.088 145.463 421.088H286.747C290.593 421.088 294.104 422.593 296.779 425.101C299.455 427.61 301.294 431.122 301.461 434.801C301.628 435.302 301.628 435.804 301.628 436.306Z"
          fill="#E0E0E0"
        />
        <path
          d="M277.384 427.777L277.886 434.466L284.239 432.125L285.744 435.47L279.223 437.644L283.738 443.33L280.895 445.504L276.548 439.65L273.037 445.504L269.86 443.33L273.539 437.644L266.851 435.47L267.854 432.125L274.542 434.466L274.04 427.777H277.384Z"
          fill="white"
        />
        <path
          d="M238.761 427.777L239.263 434.466L245.616 432.125L247.121 435.47L240.6 437.644L245.115 443.33L242.272 445.504L237.925 439.65L234.414 445.504L231.237 443.33L234.916 437.644L228.228 435.47L229.231 432.125L235.919 434.466L235.417 427.777H238.761Z"
          fill="white"
        />
        <path
          d="M200.138 427.777L200.64 434.466L206.993 432.125L208.498 435.47L201.977 437.644L206.492 443.33L203.649 445.504L199.302 439.65L195.791 445.504L192.614 443.33L196.292 437.644L189.604 435.47L190.608 432.125L197.296 434.466L196.794 427.777H200.138Z"
          fill="white"
        />
        <path
          d="M161.515 427.777L162.017 434.466L168.37 432.125L169.875 435.47L163.354 437.644L167.869 443.33L165.026 445.504L160.679 439.65L157.168 445.504L153.991 443.33L157.669 437.644L150.981 435.47L151.985 432.125L158.673 434.466L158.171 427.777H161.515Z"
          fill="white"
        />
        <path
          d="M255.314 416.071H248.793V414.399H255.481L255.314 416.071Z"
          fill="#E0E0E0"
        />
        <path
          d="M283.738 416.071H262.169V414.399H283.738V416.071Z"
          fill="#E0E0E0"
        />
        <g opacity="0.8">
          <path
            d="M450.437 407.709L477.021 448.681L564.969 360.717C565.805 359.881 564.634 358.711 563.798 359.38L480.031 425.101L464.147 399.515L450.437 407.709Z"
            fill="#E0E0E0"
          />
        </g>
        <path
          opacity="0.1"
          d="M434.553 115.724L371.352 351.854H392.586L454.952 115.724H434.553Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M467.157 115.724L404.123 351.854H446.257L508.623 115.724H467.157Z"
          fill="white"
        />
        <path
          d="M694.381 328.776L707.757 139.303C708.259 133.116 703.41 127.932 697.223 127.932L366.669 128.266C360.315 128.266 354.965 133.283 354.463 139.638L341.087 329.111C340.586 335.298 345.435 340.482 351.621 340.482L682.175 340.148C688.529 340.148 693.879 334.964 694.381 328.776Z"
          fill="#263238"
        />
        <path
          d="M690.201 324.595L703.577 135.123C704.079 128.935 699.23 123.751 693.044 123.751L362.489 124.085C356.136 124.085 350.785 129.102 350.284 135.457L336.908 324.93C336.406 331.117 341.255 336.302 347.441 336.302L677.996 335.967C684.182 335.967 689.7 330.95 690.201 324.595Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.6"
          d="M681.339 327.438C680.838 327.94 680.002 328.442 678.831 328.442L348.277 328.776C346.103 328.776 344.264 326.77 344.431 324.595L357.807 135.123C357.975 133.952 358.476 133.116 358.978 132.781C359.479 132.28 360.315 131.778 361.486 131.778L692.04 131.444C694.214 131.444 696.053 133.45 695.886 135.624L682.51 325.097C682.51 326.268 681.841 326.937 681.339 327.438Z"
          fill="white"
        />
        <path
          d="M571.489 223.253H455.452C453.445 223.253 451.606 224.926 451.272 226.933L449.433 243.823C449.265 245.83 450.77 247.502 452.777 247.502H568.813C570.82 247.502 572.659 245.83 572.993 243.823L574.833 226.933C575 224.926 573.495 223.253 571.489 223.253Z"
          fill="white"
        />
        <path
          d="M469.163 292.654H451.105C449.099 292.654 447.259 294.327 446.925 296.333L445.086 313.224C444.919 315.231 446.424 316.903 448.43 316.903H466.488C468.494 316.903 470.333 315.231 470.668 313.224L472.507 296.333C472.674 294.327 471.169 292.654 469.163 292.654Z"
          fill="white"
        />
        <path
          d="M500.429 292.654H482.372C480.365 292.654 478.526 294.327 478.192 296.333L476.353 313.224C476.185 315.231 477.69 316.903 479.697 316.903H497.754C499.761 316.903 501.6 315.231 501.934 313.224L503.773 296.333C503.941 294.327 502.436 292.654 500.429 292.654Z"
          fill="white"
        />
        <path
          d="M531.696 292.654H513.638C511.632 292.654 509.793 294.327 509.458 296.333L507.619 313.224C507.452 315.231 508.957 316.903 510.963 316.903H529.021C531.027 316.903 532.866 315.231 533.201 313.224L535.04 296.333C535.207 294.327 533.702 292.654 531.696 292.654Z"
          fill="white"
        />
        <path
          d="M562.962 292.654H544.904C542.898 292.654 541.058 294.327 540.724 296.333L538.885 313.224C538.718 315.231 540.222 316.903 542.229 316.903H560.286C562.293 316.903 564.132 315.231 564.466 313.224L566.306 296.333C566.64 294.327 565.135 292.654 562.962 292.654Z"
          fill="white"
        />
        <path
          d="M469.999 280.948H542.563C546.075 280.948 549.251 278.105 549.586 274.593L550.422 266.232C550.756 262.72 548.248 259.877 544.737 259.877H472.172C468.661 259.877 465.484 262.72 465.15 266.232L464.314 274.593C463.812 278.105 466.32 280.948 469.999 280.948Z"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M575.669 187.968H459.632C457.626 187.968 455.787 189.64 455.452 191.647L453.613 208.537C453.446 210.544 454.951 212.216 456.957 212.216H572.994C575.001 212.216 576.84 210.544 577.174 208.537L579.013 191.647C579.18 189.64 577.676 187.968 575.669 187.968Z"
          fill="white"
        />
        <path
          d="M469.497 235.461C469.664 233.12 467.993 231.281 465.819 231.281C463.478 231.281 461.472 233.12 461.304 235.461C461.137 237.803 462.809 239.642 464.983 239.642C467.157 239.642 469.33 237.803 469.497 235.461Z"
          fill="#263238"
        />
        <path
          d="M482.204 235.461C482.372 233.12 480.7 231.281 478.526 231.281C476.185 231.281 474.179 233.12 474.012 235.461C473.844 237.803 475.516 239.642 477.69 239.642C480.031 239.642 482.037 237.803 482.204 235.461Z"
          fill="#263238"
        />
        <path
          d="M495.078 235.461C495.246 233.12 493.574 231.281 491.4 231.281C489.059 231.281 487.053 233.12 486.886 235.461C486.718 237.803 488.39 239.642 490.564 239.642C492.738 239.642 494.744 237.803 495.078 235.461Z"
          fill="#263238"
        />
        <path
          d="M507.786 235.461C507.954 233.12 506.282 231.281 504.108 231.281C501.934 231.281 499.761 233.12 499.594 235.461C499.426 237.803 501.098 239.642 503.272 239.642C505.446 239.642 507.619 237.803 507.786 235.461Z"
          fill="#263238"
        />
        <path
          d="M520.827 235.461C520.995 233.12 519.323 231.281 517.149 231.281C514.808 231.281 512.802 233.12 512.635 235.461C512.467 237.803 514.139 239.642 516.313 239.642C518.487 239.642 520.493 237.803 520.827 235.461Z"
          fill="#263238"
        />
        <path
          d="M473.677 200.176C473.844 197.834 472.172 195.995 469.999 195.995C467.658 195.995 465.651 197.834 465.484 200.176C465.317 202.517 466.989 204.356 469.163 204.356C471.336 204.189 473.51 202.35 473.677 200.176Z"
          fill="#263238"
        />
        <path
          d="M486.384 200.176C486.551 197.834 484.879 195.995 482.706 195.995C480.365 195.995 478.358 197.834 478.191 200.176C478.024 202.517 479.696 204.356 481.87 204.356C484.21 204.189 486.217 202.35 486.384 200.176Z"
          fill="#263238"
        />
        <path
          d="M499.259 200.176C499.426 197.834 497.754 195.995 495.581 195.995C493.24 195.995 491.233 197.834 491.066 200.176C490.899 202.517 492.571 204.356 494.745 204.356C496.918 204.189 498.925 202.35 499.259 200.176Z"
          fill="#263238"
        />
        <path
          d="M511.966 200.176C512.133 197.834 510.461 195.995 508.288 195.995C505.947 195.995 503.94 197.834 503.773 200.176C503.606 202.517 505.278 204.356 507.452 204.356C509.625 204.356 511.799 202.35 511.966 200.176Z"
          fill="#263238"
        />
        <path
          d="M524.673 200.176C524.84 197.834 523.168 195.995 520.995 195.995C518.654 195.995 516.647 197.834 516.48 200.176C516.313 202.517 517.985 204.356 520.159 204.356C522.499 204.189 524.506 202.35 524.673 200.176Z"
          fill="#263238"
        />
        <path
          d="M537.547 200.176C537.714 197.834 536.042 195.995 533.869 195.995C531.528 195.995 529.522 197.834 529.354 200.176C529.187 202.517 530.859 204.356 533.033 204.356C535.206 204.189 537.213 202.35 537.547 200.176Z"
          fill="#263238"
        />
        <path
          d="M526.681 150.508L525.845 159.037C525.845 159.873 525.009 160.375 524.34 160.375C523.504 160.375 523.002 159.706 523.002 159.037L523.838 150.508C524.173 147.665 522.166 145.491 519.324 145.491H516.314C513.472 145.491 510.964 147.665 510.797 150.508L509.961 158.535H507.118L507.954 150.508C508.456 146.16 512.301 142.648 516.649 142.648H519.658C524.005 142.648 527.015 146.16 526.681 150.508Z"
          fill="#25ABE1"
        />
        <path
          d="M526.68 158.702L524.841 175.425C524.674 176.429 523.838 177.265 522.667 177.265H505.947C504.944 177.265 504.108 176.429 504.275 175.425L506.115 158.702C506.115 158.033 506.616 157.364 507.118 157.03C507.452 156.863 507.786 156.695 508.121 156.695H524.841C525.175 156.695 525.51 156.863 525.844 157.03C526.513 157.364 526.847 158.033 526.68 158.702Z"
          fill="#25ABE1"
        />
        <path
          d="M657.598 122.748L616.801 122.915"
          stroke="#263238"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M679.835 122.58H665.456"
          stroke="#263238"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g opacity="0.3">
          <path
            d="M393.087 131.611H439.903L392.418 328.609H354.798C354.798 328.609 354.798 328.609 354.631 328.609C349.95 328.609 346.606 324.094 347.776 319.579L393.087 131.611Z"
            fill="white"
          />
          <path
            d="M460.636 131.611H480.533L432.881 328.609H413.151L460.636 131.611Z"
            fill="white"
          />
        </g>
        <path
          d="M144.963 70.0698H154.493C144.963 70.0698 137.773 77.7624 138.442 87.2946L158.506 375.434C159.175 384.966 167.535 392.658 177.065 392.658H167.535C158.004 392.658 149.644 384.966 148.975 375.434L128.744 87.4618C128.075 77.9296 135.265 70.0698 144.963 70.0698Z"
          fill="#25ABE1"
        />
        <path
          d="M144.963 70.0698H154.494C144.963 70.0698 137.774 77.7624 138.442 87.2946L158.506 375.434C159.175 384.966 167.535 392.658 177.066 392.658H167.535C158.005 392.658 148.307 384.966 147.638 375.434L127.574 87.2946C126.738 77.9297 135.266 70.0698 144.963 70.0698Z"
          fill="#263238"
        />
        <path
          d="M170.21 392.826H286.414C295.945 392.826 303.134 385.133 302.465 375.601L282.401 87.4618C281.733 77.9296 273.373 70.237 263.842 70.237H147.638C138.108 70.237 130.918 77.9296 131.587 87.4618L151.651 375.601C152.487 385.133 160.68 392.826 170.21 392.826Z"
          fill="#25ABE1"
        />
        <g opacity="0.6">
          <path
            d="M263.675 75.7556C270.363 75.7556 276.048 81.107 276.549 87.7963L296.613 375.935C296.78 378.946 295.777 381.956 293.771 384.13C291.764 386.304 288.922 387.474 285.912 387.474H169.708C163.02 387.474 157.336 382.123 156.834 375.434L136.77 87.2946C136.603 84.2844 137.606 81.2743 139.612 79.1003C141.619 76.9263 144.461 75.7556 147.471 75.7556H263.675Z"
            fill="white"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M230.737 387.307H184.423L222.712 75.7556H259.997C263.341 75.7556 266.518 77.2607 268.524 79.4347L230.737 387.307Z"
            fill="white"
          />
          <path
            d="M176.063 387.307H165.696L203.985 75.7556H214.351L176.063 387.307Z"
            fill="white"
          />
        </g>
        <path
          d="M172.551 211.882H256.652"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M183.419 224.257H249.296"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M175.059 154.354L175.226 157.699H173.053L172.886 154.354L169.04 148.334H171.381L174.056 152.515L176.397 148.334H178.57L175.059 154.354Z"
          fill="#25ABE1"
        />
        <path
          d="M178.571 153.016C178.403 150.173 180.577 148.167 183.419 148.167C186.429 148.167 188.603 150.173 188.77 153.016C188.937 155.859 186.763 157.866 183.921 157.866C180.911 157.866 178.571 155.859 178.571 153.016ZM186.596 153.016C186.596 151.177 185.259 150.006 183.587 150.006C181.915 150.006 180.744 151.177 180.744 153.016C180.744 154.856 182.082 156.027 183.754 156.027C185.426 156.027 186.596 154.856 186.596 153.016Z"
          fill="#25ABE1"
        />
        <path
          d="M190.275 153.685L190.107 148.501H192.281L192.448 153.685C192.448 155.525 193.284 156.194 194.622 156.194C195.959 156.194 196.628 155.525 196.628 153.685L196.461 148.501H198.635L198.802 153.685C198.969 156.361 197.464 158.033 194.789 158.033C191.947 157.866 190.442 156.361 190.275 153.685Z"
          fill="#25ABE1"
        />
        <path
          d="M206.994 157.699L205.155 155.023H204.988H203.148L203.316 157.699H201.142L200.808 148.334H204.82C207.328 148.334 208.833 149.672 209 151.679C209 153.016 208.332 154.187 207.161 154.689L209.335 157.699H206.994ZM204.653 150.173H202.814L202.981 153.351H204.82C206.158 153.351 206.827 152.682 206.827 151.679C206.66 150.842 205.991 150.173 204.653 150.173Z"
          fill="#25ABE1"
        />
        <path
          d="M213.85 153.016C213.683 150.173 215.856 148.167 218.699 148.167C220.371 148.167 221.708 148.836 222.544 149.839L221.207 151.177C220.538 150.508 219.702 150.006 218.866 150.006C217.194 150.006 215.856 151.177 216.023 153.016C216.023 154.856 217.361 156.027 219.033 156.027C220.036 156.027 220.705 155.692 221.374 154.856L222.879 156.194C222.043 157.197 220.705 157.866 219.033 157.866C216.191 157.866 214.017 155.859 213.85 153.016Z"
          fill="#25ABE1"
        />
        <path
          d="M223.38 153.016C223.213 150.173 225.387 148.167 228.229 148.167C231.239 148.167 233.412 150.173 233.579 153.016C233.747 155.859 231.573 157.866 228.731 157.866C225.721 157.866 223.547 155.859 223.38 153.016ZM231.406 153.016C231.406 151.177 230.068 150.006 228.396 150.006C226.724 150.006 225.554 151.177 225.554 153.016C225.554 154.856 226.891 156.027 228.563 156.027C230.235 156.027 231.573 154.856 231.406 153.016Z"
          fill="#25ABE1"
        />
        <path
          d="M235.084 148.334H239.264C242.274 148.334 244.447 150.173 244.614 153.016C244.782 155.859 242.608 157.699 239.598 157.699H235.418L235.084 148.334ZM239.431 156.027C241.27 156.027 242.441 154.856 242.441 153.184C242.441 151.344 241.103 150.341 239.264 150.341H237.258L237.425 156.194H239.431V156.027Z"
          fill="#25ABE1"
        />
        <path
          d="M253.643 156.027V157.699H246.454L246.119 148.334H253.142V150.006H248.293V152.013H252.64V153.685H248.293V155.859H253.643V156.027Z"
          fill="#25ABE1"
        />
        <path
          d="M191.277 192.483V196.162H173.721V193.152L183.084 184.121C185.425 181.947 185.76 180.442 185.76 179.104C185.76 176.93 184.255 175.593 181.245 175.593C178.904 175.593 177.065 176.429 175.728 178.101L172.551 175.76C174.39 173.251 177.567 171.746 181.58 171.746C186.763 171.746 190.107 174.422 190.274 178.603C190.274 180.944 189.772 183.118 186.428 186.128L180.075 192.148H191.277V192.483Z"
          fill="#263238"
        />
        <path
          d="M210.672 188.971C210.672 192.985 207.83 196.496 201.309 196.496C197.965 196.496 194.621 195.493 192.28 193.654L194.119 190.142C195.791 191.647 198.467 192.483 201.142 192.483C204.319 192.483 206.158 191.145 206.158 188.804C206.158 186.63 204.486 185.292 200.975 185.292H198.801V182.282L204.151 175.76H193.283V172.081H209.502V175.091L203.817 181.947C208.331 182.784 210.672 185.459 210.672 188.971Z"
          fill="#263238"
        />
        <path
          d="M232.91 189.306C232.91 193.821 229.232 196.496 223.212 196.496C217.193 196.496 213.515 193.654 213.348 189.306C213.348 186.63 214.685 184.79 217.026 183.62C215.02 182.616 214.016 180.777 214.016 178.603C214.016 174.589 217.528 171.913 222.711 171.913C228.061 171.913 231.74 174.422 231.74 178.603C231.74 180.777 230.736 182.616 228.73 183.62C231.572 184.79 232.91 186.63 232.91 189.306ZM228.563 189.138C228.563 186.797 226.389 185.292 223.212 185.292C219.868 185.292 218.029 186.797 218.029 189.138C218.029 191.48 220.036 192.985 223.38 192.985C226.556 192.985 228.563 191.647 228.563 189.138ZM218.531 178.77C218.531 180.777 220.37 182.115 223.045 182.115C225.888 182.115 227.56 180.777 227.56 178.77C227.56 176.596 225.72 175.425 222.878 175.425C220.203 175.425 218.531 176.763 218.531 178.77Z"
          fill="#263238"
        />
        <path
          d="M255.147 189.306C255.147 193.821 251.469 196.496 245.45 196.496C239.598 196.496 235.752 193.654 235.585 189.306C235.585 186.63 236.923 184.79 239.263 183.62C237.257 182.616 236.254 180.777 236.254 178.603C236.254 174.589 239.765 171.913 244.948 171.913C250.299 171.913 253.977 174.422 253.977 178.603C253.977 180.777 252.974 182.616 250.967 183.62C253.81 184.79 255.147 186.63 255.147 189.306ZM250.8 189.138C250.8 186.797 248.627 185.292 245.45 185.292C242.106 185.292 240.267 186.797 240.267 189.138C240.267 191.48 242.273 192.985 245.617 192.985C248.794 192.985 250.8 191.647 250.8 189.138ZM240.768 178.77C240.768 180.777 242.607 182.115 245.283 182.115C248.125 182.115 249.797 180.777 249.797 178.77C249.797 176.596 247.958 175.425 245.115 175.425C242.44 175.425 240.768 176.763 240.768 178.77Z"
          fill="#263238"
        />
        <path
          d="M128.243 111.878L131.253 152.347"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.905 93.4821L127.741 104.185"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M206.325 53.3467V28.5965"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M186.763 58.5308L174.558 37.1253"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M238.093 37.1253L225.721 58.5308"
          stroke="#25ABE1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M524.841 489.987C516.314 523.768 512.97 558.886 514.642 593.837"
          stroke="#25ABE1"
          strokeMiterlimit="10"
        />
        <path
          d="M516.982 488.649C516.982 491.827 519.825 502.864 523.002 502.697C526.178 502.697 528.352 491.492 528.352 488.315C528.352 485.137 525.677 482.796 522.5 482.796C519.49 482.796 516.982 485.472 516.982 488.649Z"
          fill="#25ABE1"
        />
        <path
          d="M529.188 523.768C529.188 520.59 526.346 509.553 523.169 509.72C519.992 509.72 517.818 520.925 517.818 524.102C517.818 527.279 520.494 529.621 523.67 529.621C526.847 529.454 529.188 526.778 529.188 523.768Z"
          fill="#25ABE1"
        />
        <path
          d="M505.613 512.229C508.79 512.229 519.825 509.386 519.658 506.208C519.658 503.031 508.455 500.857 505.278 500.857C502.102 500.857 499.761 503.533 499.761 506.71C499.761 509.887 502.436 512.229 505.613 512.229Z"
          fill="#25ABE1"
        />
        <path
          d="M540.724 500.021C537.548 500.021 526.512 502.864 526.68 506.041C526.68 509.219 537.882 511.393 541.059 511.393C544.236 511.393 546.576 508.717 546.576 505.539C546.409 502.529 543.734 500.021 540.724 500.021Z"
          fill="#25ABE1"
        />
        <path
          d="M506.449 498.014C508.79 500.188 518.487 506.041 520.661 503.7C522.835 501.359 516.481 491.994 514.307 489.82C511.967 487.646 508.455 487.813 506.282 489.987C504.108 492.328 504.108 495.84 506.449 498.014Z"
          fill="#25ABE1"
        />
        <path
          d="M539.722 514.235C537.381 512.061 527.684 506.208 525.51 508.55C523.336 510.891 529.69 520.256 531.864 522.43C534.204 524.604 537.716 524.437 539.889 522.263C542.23 519.921 542.063 516.409 539.722 514.235Z"
          fill="#25ABE1"
        />
        <path
          d="M514.976 522.932C517.15 520.59 523.002 510.891 520.661 508.717C518.32 506.543 508.957 512.898 506.783 515.072C504.61 517.413 504.777 520.925 506.951 523.099C509.291 525.273 512.803 525.106 514.976 522.932Z"
          fill="#25ABE1"
        />
        <path
          d="M531.195 489.485C529.021 491.827 523.169 501.526 525.51 503.7C527.851 505.874 537.214 499.519 539.387 497.345C541.561 495.004 541.394 491.492 539.22 489.318C536.879 487.144 533.368 487.144 531.195 489.485Z"
          fill="#25ABE1"
        />
        <path
          d="M523.328 512.89C527.02 512.801 529.941 509.734 529.852 506.041C529.763 502.348 526.697 499.426 523.004 499.515C519.312 499.605 516.391 502.671 516.48 506.364C516.569 510.058 519.635 512.979 523.328 512.89Z"
          fill="white"
        />
        <path
          d="M515.478 556.043C515.478 556.043 516.648 538.986 526.011 536.31C535.374 533.634 538.886 529.955 538.886 529.955C538.886 529.955 537.882 556.378 515.478 556.043Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.5"
          d="M515.478 556.043C515.478 556.043 516.648 538.986 526.011 536.31C535.374 533.634 538.886 529.955 538.886 529.955C538.886 529.955 537.882 556.378 515.478 556.043Z"
          fill="white"
        />
        <path
          d="M514.139 569.087C514.139 569.087 512.969 552.03 503.606 549.354C494.243 546.678 490.731 542.999 490.731 542.999C490.731 542.999 491.735 569.422 514.139 569.087Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.5"
          d="M514.139 569.087C514.139 569.087 512.969 552.03 503.606 549.354C494.243 546.678 490.731 542.999 490.731 542.999C490.731 542.999 491.735 569.422 514.139 569.087Z"
          fill="white"
        />
        <path
          d="M549.586 604.707C549.586 618.086 533.702 628.789 514.14 628.789C494.577 628.789 478.693 617.919 478.693 604.707C478.693 598.018 482.706 591.831 489.394 587.483C493.24 584.974 497.754 582.967 502.937 581.797H525.342C530.693 582.967 535.374 584.974 539.22 587.65C545.573 592.165 549.586 598.018 549.586 604.707Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.8"
          d="M525.342 581.797C530.693 582.967 535.374 584.974 539.22 587.65C545.573 591.998 549.586 598.018 549.586 604.707C549.586 618.086 533.702 628.789 514.14 628.789C494.577 628.789 478.693 617.919 478.693 604.707C478.693 598.018 482.706 591.831 489.394 587.483C493.24 584.974 497.754 582.967 502.937 581.797H525.342Z"
          fill="white"
        />
        <path
          d="M514.307 583.971C514.307 587.984 514.307 591.998 514.307 595.844"
          stroke="#25ABE1"
          strokeMiterlimit="10"
        />
        <path
          d="M540.891 581.462L538.885 587.315V587.483H489.394L489.227 587.148L487.555 581.462H540.891Z"
          fill="#25ABE1"
        />
        <path
          d="M545.406 609.557C542.062 614.574 537.046 618.42 531.863 621.263C523.335 625.779 487.555 626.949 483.542 606.547C483.542 606.213 483.375 606.045 483.375 605.711C482.371 600.36 487.053 595.677 492.571 596.179C495.915 596.513 499.426 596.179 502.77 595.677C515.644 593.67 528.853 594.506 541.226 597.684C546.075 599.189 548.415 605.209 545.406 609.557Z"
          fill="#263238"
        />
        <path
          d="M288.42 602.868C289.089 602.701 289.424 602.199 289.591 601.363C289.758 600.861 289.591 600.359 289.256 600.192C287.919 598.854 282.736 599.858 282.067 599.858C281.9 599.858 281.9 600.025 281.732 600.192C281.732 600.359 281.732 600.527 281.9 600.527C282.736 601.196 284.073 602.032 285.244 602.533C286.581 602.868 287.584 603.035 288.42 602.868ZM288.922 600.694C289.089 600.861 289.089 600.861 289.089 601.196C288.922 601.697 288.755 602.032 288.253 602.199C287.25 602.534 285.411 601.865 283.237 600.527C285.411 600.192 288.253 600.025 288.922 600.694Z"
          fill="#25ABE1"
        />
        <path
          d="M282.401 600.527C284.073 600.359 287.751 598.52 288.085 596.848C288.085 596.513 288.085 596.011 287.417 595.51C286.915 595.175 286.413 595.175 285.912 595.343C283.905 596.011 282.233 599.858 282.233 600.025C282.233 600.192 282.233 600.192 282.233 600.359L282.401 600.527ZM286.915 596.179C287.249 596.346 287.249 596.68 287.249 596.848C287.082 597.851 284.574 599.356 282.902 599.858C283.571 598.687 284.741 596.513 285.912 596.179C286.246 596.011 286.581 596.011 286.915 596.179Z"
          fill="#25ABE1"
        />
        <path
          d="M266.517 593.837L280.227 599.356L292.098 567.917L278.388 562.398L266.517 593.837Z"
          fill="#FFB573"
        />
        <path
          d="M281.899 598.185L266.684 591.998C266.182 591.831 265.514 591.998 265.179 592.5L258.491 603.704C257.822 604.875 258.324 606.547 259.662 607.049C265.012 609.055 267.687 609.892 274.375 612.567C278.555 614.24 284.407 617.083 290.092 619.424C295.61 621.765 298.452 616.246 296.278 614.909C286.581 608.387 286.246 604.54 283.738 600.192C283.404 599.189 282.735 598.52 281.899 598.185Z"
          fill="#263238"
        />
        <path
          d="M291.931 583.302L268.188 573.77L270.362 565.074L295.776 574.439L291.931 583.302Z"
          fill="#25ABE1"
        />
        <path
          d="M315.506 219.24C310.657 233.12 296.445 265.897 285.577 252.184C283.571 249.676 281.899 247.167 280.728 244.157C276.047 232.618 274.877 214.056 274.375 210.042L270.696 197.333C270.696 197.165 270.529 196.831 270.529 196.664V189.473C270.529 186.463 272.87 184.79 276.047 185.125C276.047 185.125 281.23 184.456 281.23 187.633L282.233 198.503C282.735 202.35 281.23 207.534 282.066 211.046C285.41 224.09 289.924 224.759 292.934 238.304C296.947 228.605 304.136 211.715 304.136 211.715C309.152 212.216 317.178 214.725 315.506 219.24Z"
          fill="#FFB573"
        />
        <path
          d="M298.452 257.201C295.108 262.218 287.751 262.553 284.24 257.703C282.066 254.693 280.394 251.515 279.558 249.007C275.211 234.792 272.536 225.929 272.201 211.046C275.211 207.868 280.227 206.698 284.24 208.203L291.429 232.284C291.429 232.284 305.976 196.329 311.828 194.991C318.683 193.486 321.692 199.674 324.535 207.199C326.541 212.718 307.815 242.652 298.452 257.201Z"
          fill="#25ABE1"
        />
        <path
          d="M356.971 158.87C355.299 167.231 351.621 185.459 357.473 191.145C357.473 191.145 355.132 199.674 339.582 199.674C322.528 199.674 331.389 191.145 331.389 191.145C340.753 188.971 340.418 181.947 338.913 175.425L356.971 158.87Z"
          fill="#FFB573"
        />
        <path
          d="M330.721 139.136C330.888 139.136 330.888 139.136 331.055 139.136C331.39 138.969 331.557 138.635 331.39 138.3C329.718 134.955 326.708 134.621 326.541 134.621C326.206 134.621 325.872 134.788 325.872 135.29C325.872 135.624 326.039 135.959 326.374 135.959C326.541 135.959 328.882 136.293 330.219 138.969C330.386 138.969 330.554 139.136 330.721 139.136Z"
          fill="#263238"
        />
        <path
          d="M325.705 146.494C325.705 146.494 323.197 151.177 320.856 153.184C322.194 154.689 324.702 154.354 324.702 154.354L325.705 146.494Z"
          fill="#ED893E"
        />
        <path
          d="M326.133 146.296C326.855 146.14 327.25 145.135 327.015 144.052C326.78 142.969 326.005 142.217 325.283 142.374C324.561 142.531 324.166 143.536 324.401 144.619C324.636 145.702 325.411 146.453 326.133 146.296Z"
          fill="#263238"
        />
        <path
          d="M325.705 142.314L322.862 142.146C322.862 142.146 324.534 143.819 325.705 142.314Z"
          fill="#263238"
        />
        <path
          opacity="0.2"
          d="M314.837 212.049C317.847 209.373 319.853 210.209 321.191 212.383C322.529 218.571 314.503 231.782 311.326 236.799L314.837 212.049Z"
          fill="black"
        />
        <path
          d="M383.389 220.411C383.054 227.267 382.386 235.963 381.215 246.833C380.045 258.372 378.54 272.419 376.366 289.31C353.627 289.31 329.885 288.975 318.85 288.975C319.853 266.399 320.187 243.488 309.988 198.503C309.486 196.162 310.991 193.821 313.332 193.319C317.846 192.483 325.538 191.312 333.229 190.978C342.926 190.476 350.785 190.142 359.312 190.978C370.514 191.981 383.222 194.657 383.222 194.657C383.222 194.657 384.559 198.838 383.389 220.411Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.2"
          d="M383.389 220.411C383.054 227.267 382.386 235.963 381.215 246.833C375.029 239.809 369.344 215.394 371.183 207.032C375.698 210.042 379.878 214.892 383.054 219.073C383.222 219.407 383.389 219.909 383.389 220.411Z"
          fill="black"
        />
        <path
          d="M442.411 251.014L454.115 244.492L456.288 256.365C456.288 256.365 446.423 260.212 441.24 257.536L442.411 251.014Z"
          fill="#FFB573"
        />
        <path
          d="M461.806 245.83L462.642 249.676C462.976 250.847 462.307 252.184 461.304 252.853L456.121 256.365L453.947 244.492L457.96 243.488C459.799 242.987 461.471 243.99 461.806 245.83Z"
          fill="#FFB573"
        />
        <path
          d="M372.187 208.537C375.865 216.063 389.575 244.826 395.595 251.515L396.765 252.686L397.434 253.355C397.601 253.522 397.768 253.689 398.103 254.024C399.273 255.027 400.443 256.031 401.614 256.7C404.122 258.205 406.463 259.041 408.971 259.71C413.652 260.88 418.334 261.048 422.681 261.048C431.543 260.713 439.735 259.208 447.928 256.7L446.423 249.676C442.578 250.01 438.565 250.178 434.552 250.345C430.539 250.512 426.694 250.345 423.015 250.01C419.17 249.676 415.659 249.007 412.482 248.004C410.977 247.502 409.639 246.833 408.636 245.997C408.135 245.662 407.8 245.328 407.466 244.826C407.466 244.826 407.299 244.492 407.131 244.325L406.63 243.823L405.794 242.819C401.112 236.966 388.907 209.206 385.395 202.182L372.187 208.537Z"
          fill="#FFB573"
        />
        <path
          d="M442.243 262.887C432.713 268.071 421.176 269.075 410.977 265.897C401.112 262.887 392.417 255.696 387.401 246.833C381.382 237.97 365.331 212.885 367.337 206.363C369.678 198.67 374.861 193.821 383.389 195.828C389.408 197.333 400.777 226.264 406.295 237.803C408.469 240.98 412.649 246.164 417.163 247.669C425.356 250.512 431.375 249.341 439.902 248.004C441.407 249.007 441.407 250.345 442.076 252.017C443.581 255.529 443.915 259.543 442.243 262.887Z"
          fill="#25ABE1"
        />
        <path
          d="M365.331 145.491C362.823 159.204 361.987 165.057 354.129 171.412C342.258 180.777 325.872 174.589 324.367 160.375C322.862 147.498 327.377 127.263 341.589 123.417C355.634 119.57 368.006 131.778 365.331 145.491Z"
          fill="#FFB573"
        />
        <path
          d="M414.154 221.581C411.479 224.591 410.643 226.264 407.132 227.936C403.453 229.608 395.595 228.103 393.087 225.093C393.923 227.434 398.772 231.782 401.28 232.117C395.762 235.294 387.904 233.956 383.724 229.107C384.058 232.117 386.9 234.625 389.743 235.629C357.64 236.465 371.184 221.414 351.12 200.008C328.882 176.262 333.731 156.695 333.731 156.695C333.731 153.351 332.895 147.665 329.384 143.15C326.207 138.969 327.043 133.45 328.046 130.44C329.551 125.925 334.065 124.253 338.412 124.085C339.248 119.57 348.444 120.406 349.615 121.243C350.618 121.911 350.952 121.911 351.956 121.243C354.296 119.737 359.981 118.232 366 123.249C369.679 126.259 373.692 131.611 373.859 143.15C374.026 155.023 368.341 169.238 388.071 187.299C399.273 197.5 393.756 220.411 414.154 221.581Z"
          fill="#263238"
        />
        <path
          d="M330.888 146.494C329.216 148.836 328.715 151.679 329.049 154.02C329.551 157.532 333.062 157.866 335.57 155.525C337.743 153.518 340.251 149.17 338.412 146.327C336.573 143.484 332.727 143.819 330.888 146.494Z"
          fill="#FFB573"
        />
        <path
          d="M361.82 289.31C361.82 289.31 354.965 385.3 347.274 448.681C344.933 467.578 339.248 485.973 330.219 503.031L292.599 574.104L273.204 566.579C273.204 566.579 286.58 498.85 312.663 462.059C312.663 462.059 293.101 351.854 318.683 289.142L361.82 289.31Z"
          fill="#263238"
        />
        <path
          opacity="0.2"
          d="M335.57 312.555C335.57 312.555 341.255 356.035 344.432 381.956C332.728 366.403 323.532 344.663 335.57 312.555Z"
          fill="black"
        />
        <path
          d="M410.643 611.898C411.144 611.397 411.144 610.728 410.977 610.059C410.81 609.557 410.475 609.223 410.141 609.223C408.302 608.554 404.122 611.898 403.787 612.233C403.62 612.4 403.62 612.4 403.62 612.567C403.62 612.735 403.787 612.735 403.955 612.735C404.958 612.902 406.463 613.069 407.8 612.902C409.138 612.735 410.141 612.4 410.643 611.898ZM410.141 609.724C410.308 609.724 410.475 609.892 410.475 610.059C410.643 610.561 410.475 611.062 410.308 611.23C409.639 611.898 407.8 612.233 405.125 612.066C406.797 610.895 409.138 609.39 410.141 609.724Z"
          fill="#25ABE1"
        />
        <path
          d="M404.289 612.567C405.627 611.731 407.967 608.219 407.466 606.714C407.299 606.38 407.131 605.878 406.128 605.878C405.627 605.878 405.125 606.045 404.624 606.547C403.119 608.052 403.62 612.233 403.62 612.4C403.62 612.567 403.788 612.567 403.788 612.735C403.955 612.735 404.122 612.735 404.289 612.567C404.289 612.735 404.289 612.735 404.289 612.567ZM406.296 606.547C406.797 606.547 406.797 606.714 406.964 606.881C407.299 607.885 405.794 610.393 404.624 611.564C404.624 610.226 404.624 607.885 405.46 606.881C405.46 606.714 405.794 606.714 406.296 606.547C406.128 606.547 406.128 606.547 406.296 606.547Z"
          fill="#25ABE1"
        />
        <path
          d="M387.067 614.072L401.781 612.567L397.266 579.288L382.553 580.793L387.067 614.072Z"
          fill="#FFB573"
        />
        <path
          d="M402.784 610.895L386.399 612.4C385.73 612.4 385.395 612.902 385.395 613.571L384.727 626.615C384.727 627.953 385.897 629.123 387.402 628.956C393.087 628.287 395.929 627.785 403.119 626.949C407.633 626.447 414.154 626.28 420.34 625.779C426.359 625.277 426.192 619.089 423.684 618.922C411.98 617.584 409.807 614.407 405.627 611.564C404.456 610.895 403.62 610.728 402.784 610.895Z"
          fill="#263238"
        />
        <path
          d="M376.367 289.31C376.367 289.31 395.093 403.863 398.771 471.759L399.44 593.336L384.225 596.346C384.225 596.346 362.322 518.751 359.814 473.933C353.126 355.032 314.335 354.864 337.743 289.142L376.367 289.31Z"
          fill="#263238"
        />
        <path
          d="M404.456 593.837L379.376 597.349L376.868 587.65L403.62 584.138L404.456 593.837Z"
          fill="#25ABE1"
        />
        <path
          d="M269.192 166.395H270.196C269.192 166.395 268.524 167.231 268.524 168.067L270.028 197.165C270.028 198.169 270.864 198.838 271.868 198.838H270.864C269.861 198.838 269.025 198.002 269.025 197.165L267.52 168.067C267.353 167.231 268.189 166.395 269.192 166.395Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.1"
          d="M269.192 166.395H270.196C269.192 166.395 268.524 167.231 268.524 168.067L270.028 197.165C270.028 198.169 270.864 198.838 271.868 198.838H270.864C269.861 198.838 269.025 198.002 269.025 197.165L267.52 168.067C267.353 167.231 268.189 166.395 269.192 166.395Z"
          fill="white"
        />
        <path
          d="M271.198 199.005H282.902C283.906 199.005 284.574 198.169 284.574 197.333L283.07 168.234C283.07 167.231 282.234 166.562 281.23 166.562H269.526C268.523 166.562 267.854 167.398 267.854 168.234L269.359 197.333C269.359 198.336 270.195 199.005 271.198 199.005Z"
          fill="#25ABE1"
        />
        <path
          opacity="0.4"
          d="M271.198 199.005H282.902C283.906 199.005 284.574 198.169 284.574 197.333L283.07 168.234C283.07 167.231 282.234 166.562 281.23 166.562H269.526C268.523 166.562 267.854 167.398 267.854 168.234L269.359 197.333C269.359 198.336 270.195 199.005 271.198 199.005Z"
          fill="white"
        />
        <path
          d="M283.739 196.664C283.739 196.998 283.571 197.165 283.404 197.5C283.237 197.667 282.903 197.834 282.568 197.834H271.199C270.53 197.834 270.028 197.333 270.028 196.664L268.523 168.402C268.523 168.067 268.691 167.9 268.858 167.566C269.025 167.398 269.359 167.231 269.694 167.231H281.063C281.732 167.231 282.234 167.733 282.234 168.402L282.401 170.408L283.739 196.664Z"
          fill="#263238"
        />
        <g opacity="0.1">
          <path
            d="M282.401 170.408L278.555 197.667H274.041L278.388 167.064H281.063C281.732 167.064 282.234 167.566 282.234 168.234L282.401 170.408Z"
            fill="white"
          />
          <path
            d="M272.537 197.834H271.366L275.713 167.231H276.717L272.537 197.834Z"
            fill="white"
          />
        </g>
        <path
          d="M315.172 292.654C306.645 309.377 301.963 327.94 301.796 346.67C330.22 368.744 356.638 342.824 389.242 347.339C388.071 332.623 383.055 305.531 377.203 291.985C355.634 292.822 335.57 290.648 315.172 292.654Z"
          fill="#25ABE1"
        />
        <path
          d="M318.182 286.634C318.182 286.634 315.841 292.487 316.51 292.487H376.2C376.702 292.487 377.203 292.153 377.203 291.985L377.705 286.969C377.705 286.634 377.371 286.3 376.702 286.3H319.185C318.683 286.132 318.349 286.467 318.182 286.634Z"
          fill="white"
        />
        <path
          d="M326.542 292.989H325.037C324.702 292.989 324.535 292.822 324.535 292.654L325.204 285.965C325.204 285.798 325.538 285.631 325.873 285.631H327.378C327.712 285.631 327.879 285.798 327.879 285.965L327.21 292.654C327.21 292.822 326.876 292.989 326.542 292.989Z"
          fill="#25ABE1"
        />
        <path
          d="M363.995 292.989H362.49C362.155 292.989 361.988 292.822 361.988 292.654L362.657 285.965C362.657 285.798 362.991 285.631 363.326 285.631H364.831C365.165 285.631 365.332 285.798 365.332 285.965L364.663 292.654C364.496 292.822 364.329 292.989 363.995 292.989Z"
          fill="#25ABE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_271_97">
          <rect width="836" height="642" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
